import { Fragment } from 'react'
import { useFormContext } from 'react-hook-form'
import { useCalculatedAmounts } from 'src/hooks/useCalculatedAmounts'
import { InvoiceFormInputs } from '../InvoiceEditForm'

export const SummaryBox: React.FC = () => {
  const { watch } = useFormContext<InvoiceFormInputs>()
  const { calculated_amount } = useCalculatedAmounts(
    watch('items'),
    watch('taxSettings')
  )
  const items = watch('items')
  const baseYPosition =
    items.length > 16
      ? 60 + items.slice(16, 30).length * 24 + 24
      : items.length > 12
      ? 60
      : 352.5 + Math.max(0, items.length - 4) * 24
  return (
    <>
      {[
        {
          label: '小計',
          value: `¥${
            calculated_amount.invoice_items
              ? calculated_amount.invoice_items
                  .reduce((previous, current) => {
                    return previous + current.amount
                  }, 0)
                  .toLocaleString()
              : 0
          }`
        },
        {
          label: '消費税',
          value: ` ¥${(isNaN(
            calculated_amount?.calculated_amount.tax_amount_of_tax_rate_10 +
              calculated_amount?.calculated_amount.tax_amount_of_tax_rate_8
          )
            ? 0
            : calculated_amount?.calculated_amount.tax_amount_of_tax_rate_10 +
              calculated_amount?.calculated_amount.tax_amount_of_tax_rate_8
          ).toLocaleString()}`
        },
        {
          label: '源泉徴収税',
          value: ` -¥${(
            calculated_amount?.calculated_amount.withholding_amount ?? 0
          ).toLocaleString()}`
        },
        {
          label: '合計',
          value: `¥${(
            calculated_amount?.calculated_amount.total_amount ?? 0
          ).toLocaleString()}`
        }
      ].map((v, i) => (
        <Fragment key={i}>
          <rect
            width="60"
            height="24"
            x="336"
            y={baseYPosition + i * 24}
            fill="#EAEAEA"
          />
          <line
            x1="336"
            y1={baseYPosition + 24 + i * 24}
            x2="464"
            y2={baseYPosition + 24 + i * 24}
            stroke="#EAEAEA"
          />
          <text
            x="366"
            y={baseYPosition + 16.5 + i * 24}
            fill="#0D0D0D"
            fontSize={'10px'}
            textAnchor="middle"
          >
            {v.label}
          </text>
          <text
            x="450"
            y={baseYPosition + 16.5 + i * 24}
            fill="#0D0D0D"
            fontSize={'10px'}
            textAnchor={'end'}
          >
            {v.value}
          </text>
        </Fragment>
      ))}
    </>
  )
}
